// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3S56Z","file":"styles_file__1DECI"};